import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    ViewChild,
} from "@angular/core";

import { Context } from "@hermes/app-core";

const MAX_LINES = 10;

@Component({
    selector: "h-product-info-description",
    templateUrl: "./product-info-description.component.html",
    styleUrls: ["./product-info-description.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductInfoDescriptionComponent {
    @Input() public maxLines: number = MAX_LINES;

    @ViewChild("descriptionElement") public descriptionElement?: ElementRef;
    public isTruncated: boolean = true;
    public showToggle: boolean = false;
    public maxHeight?: number;

    public inputDescription: string = "";

    constructor(
        private context: Context,
        private changeDetector: ChangeDetectorRef,
    ) {}

    @Input()
    public set description(description: string) {
        this.inputDescription = description;
        this.changeDetector.detectChanges();
        if (this.context.isInBrowserMode()) {
            this.checkIfTruncated();
        }
    }

    public toggleDescription() {
        this.isTruncated = !this.isTruncated;
        this.checkIfTruncated();
    }

    private checkIfTruncated() {
        this.showToggle = false;
        if (this.descriptionElement) {
            const element = this.descriptionElement.nativeElement;
            const lineHeightValue = getComputedStyle(element).lineHeight;
            const lineHeight = Number.parseInt(lineHeightValue, MAX_LINES);
            if (!Number.isNaN(lineHeight)) {
                this.maxHeight = lineHeight * this.maxLines;
                this.showToggle = element.scrollHeight > this.maxHeight;
                element.style.maxHeight = this.isTruncated
                    ? `${this.maxHeight}px`
                    : "none";
            }
        }
        this.changeDetector.markForCheck();
    }
}
